import styled from "styled-components";

export const PageWrapper = styled.div`
    /* fixe Inhaltsbreite zentral definieren */
    --content-width: 1200px;

    font-family: 'Segoe UI', sans-serif;
    background-color: #fff;
    color: #1a202c;

    /* Layout */
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 0;

    /* Breite „locken“ und zentrieren */
    width: min(100%, var(--content-width));
    margin: 0 auto;
    box-sizing: border-box;

    /* seitliche Luft, damit’s auf kleineren Screens nicht klebt */
    padding-inline: 24px;

    /* nichts abschneiden */
    overflow: visible;
`;
